import Component from './MainMenu'

export default Component

export * from './MainMenu'
